import { Box } from '@mui/material'
import type React from 'react'
import { Footer } from '../footer'
import Header from '../header'

export const PAGE_MARGIN_X = 5.2
export const PAGE_MARGIN_TOP = 3.7

export const Layout = (props: {
  children: React.ReactNode
}): JSX.Element => {
  return (
    <Box sx={{ height: '100vh', width: '100%', backgroundColor: 'var(--off-white)' }}>
      <Header />
      <Box
        sx={{
          p: 0,
          mx: `${PAGE_MARGIN_X}vw`,
          mt: `${PAGE_MARGIN_TOP}vh`,
          pb: '69px', // includes the height of the footer + 40px
          flexWrap: '',
          justifyContent: 'start'
        }}
      >
        <Box width='100%'>
          {props.children}
        </Box>
      </Box>

      <Footer />
    </Box>
  )
}
